import { render } from "./VegStarters.vue?vue&type=template&id=b64f1b2c"
import script from "./VegStarters.vue?vue&type=script&lang=js"
export * from "./VegStarters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__